import { useBankingAccountsSync } from "Api/Mutations/Accounts/useBankingAccountsSync";
import { useLoggedInUser } from "Hooks/useLoggedInUser";
import { useEffect } from "react";

/**
 * Syncs bank accounts when a dashboard mounts — but only once the active context has a region.
 * A region-less, market-scoped user would be rejected by RequireRegionMiddleware (403), so we hold the
 * sync until they pick a region. The `isRegionRequired` dependency re-fires the sync the moment the
 * gate clears (after the user confirms their region and user-info refreshes the flag).
 */
export const useSyncAccountsWhenRegionReady = () => {
  const { mutate: syncAccounts } = useBankingAccountsSync();
  const user = useLoggedInUser();
  const isRegionRequired = user?.regionRequired ?? false;

  useEffect(() => {
    if (isRegionRequired) {
      return;
    }

    syncAccounts();
  }, [syncAccounts, isRegionRequired]);
};
